import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 40000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retries transient failures (network/timeout/cold-start/502/503/504) so a slow or
// waking backend never surfaces as a scary "Something went wrong" to the user.
export async function apiPostRetry(url, data, { retries = 3, delayMs = 900 } = {}) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await api.post(url, data);
    } catch (e) {
      lastErr = e;
      const status = e.response?.status;
      const transient = !e.response || status === 502 || status === 503 || status === 504 || e.code === "ECONNABORTED";
      if (!transient || attempt === retries) throw e;
      await new Promise((r) => setTimeout(r, delayMs * (attempt + 1)));
    }
  }
  throw lastErr;
}

// Turns any error into a user-friendly message. A real API error (e.g. wrong password)
// carries a `detail`; a network/timeout error does not.
export function friendlyAuthError(e) {
  const detail = e.response?.data?.detail;
  if (detail != null) return formatApiErrorDetail(detail);
  return "We couldn't reach the server just now. Please check your connection and try again in a moment.";
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
